import { render, staticRenderFns } from "./AddCase.vue?vue&type=template&id=0daaef36&scoped=true&"
import script from "./AddCase.vue?vue&type=script&lang=js&"
export * from "./AddCase.vue?vue&type=script&lang=js&"
import style0 from "./AddCase.vue?vue&type=style&index=0&id=0daaef36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daaef36",
  null
  
)

export default component.exports